import React, {useState, useEffect} from 'react'
import '../css/components/ManageOrder.css';
import Loading from '../general/Loading';
import 'swiper/css';
import SaleOrderInvoice from './SaleOrderInvoice';
import EditSale from './EditSale';

const SaleHistory = ({setResponse, userData}) => {
            const [loading, setLoading] = useState(false);
            const [searchQuery, setSearchQuery] = useState('');
            const [orders, setOrders] = useState([]);
            const [selectedOrder, setSelectedOrder] = useState('');
const [adjustOrder, setAdjustOrder] = useState(null);
const [receivedAmount, setReceivedAmount] = useState('');
const [showDetail, setShowDetail] = useState(false);
const [selectedDate, setSelectedDate] = useState(() => {
  const today = new Date().toISOString().split("T")[0];
  return today;
});
const [showEdit, setShowEdit] = useState(false);





  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


const fetchOrders = async (date) => {
  setLoading(true);

  try {
    const response = await fetch(`https://api.hargharmart.com/get-sale-orders?date=${date}`);
    
    if (response.ok) {
      const data = await response.json();
      setOrders(data);
    }
  } catch (err) {
    console.error("Error loading:", err);
  } finally {
    setLoading(false);
  }
};



    const filterOrders = orders.filter(myItem =>
  (myItem.id?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
  myItem.user_name?.toString().toLowerCase().includes(searchQuery.toLowerCase())
)
);


useEffect(() => {
  fetchOrders(selectedDate);
}, []);

    const handleShowDetail = (order) => {
    setSelectedOrder(order);
    setShowDetail(true);
  }

      const handleEditOrder = (order) => {
    setSelectedOrder(order);
    setShowEdit(true);
  }


const handleAdjustBill = (order) => {
  setAdjustOrder(order);
};


const handleUpdateReceived = async () => {
  try {
    const res = await fetch(
      "https://api.hargharmart.com/update-sale-received",
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: adjustOrder.id,
          received: receivedAmount
        })
      }
    );

    const data = await res.json();

    if (!res.ok) throw new Error(data.message);

    setResponse({ message: "Due payment updated", status: "success" });

    setAdjustOrder(null);
    setReceivedAmount('');

    fetchOrders(selectedDate);

  } catch (err) {
    // console.error(err);
    setResponse({ message: "Failed to update", status: "error" });
  } finally {
    setTimeout(() => setResponse(''), 2000);
  }
};

  return (
    <>
              <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>Sale History</p>
        </div>

                    <div className='d-flex'>

                    <div className='d-flex bg-white rounded-2 py-2 w-100'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search By Order Id"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />                        
                    </div>

                      <input
    type="date"
    className="form-control mx-2"
    style={{ maxWidth: "150px" }}
    value={selectedDate}
    onChange={(e) => setSelectedDate(e.target.value)}
  />

  {/* FILTER BUTTON */}
  <button
    className="btn btn-dark"
    onClick={() => fetchOrders(selectedDate)}
  >
    Filter
  </button>
  </div>

<div className='table-responsive bg-white p-3 my-3 rounded-2'>
<table className='w-100'>

<thead className='inventory-row'>
        <th className='py-2'>Inv No</th>
    <th className='py-2'>Date</th>  
    <th className='py-2'>Customer</th>  
    <th className='py-2'>Grand Total</th>  
    <th className='py-2'>Received</th>  
    <th className='py-2'>Due</th>  
    <th className='py-2'>Activity</th>  
    </thead>





                                  {filterOrders.map(order => {
                                  return (

<tr className='inventory-row'>
<td className='py-2'>#{order.id}</td>
<td className='py-2'>{formatDateTime(order.order_date)}</td>
<td className='py-2'>{order.name}</td>
<td className='py-2'>₹ {Math.round(Number(order.total_amount) + Number(order.charges))}</td>
<td className='py-2 text-success'>₹ {Math.round(order.received)}</td>
<td className='py-2 text-danger'>
  ₹ {Math.round(
    Number(order.total_amount) +
    Number(order.charges) -
    Number(order.received)
  )}
</td><td className='py-2 '>
    <span className='ms-2 edit-btn p-2' onClick={() => handleShowDetail(order)}>View</span> 
      <span className='ms-2 close-btn p-2' onClick={() => handleEditOrder(order)}>Edit</span> 
       {Math.round(Number(order.total_amount) - Number(order.received)) > 0 &&
    <span className='ms-2 close-btn bg-danger p-2' onClick={() => handleAdjustBill(order)}>Adjust Bill</span>    }
</td>
</tr>
   )   }   )}

   </table>
</div>


</div>
</section>


{showDetail && 
<SaleOrderInvoice
setShowDetail={setShowDetail} selectedOrder={selectedOrder} userData={userData} />
}


{adjustOrder && (
                <section className='detail-dialog px-4 py-4 overflow-y-auto'>
                    <div className='detail-dialog-inner col-md-5 animate__animated animate__zoomIn rounded mx-auto px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

      <p className='fw-semibold fs-5'>Adjust Payment</p>

      <p className='my-0'>Order ID: #{adjustOrder.id}</p>
      <p>Grand Total: ₹{Math.round(Number(adjustOrder.total_amount) + Number(adjustOrder.charges))}</p>
      <p className='text-danger fw-bold'>Due Amount: ₹{(Math.round(Number(adjustOrder.total_amount) + Number(adjustOrder.charges)) - Number(adjustOrder.received))}</p>

      <input
        type="number"
        className="product-control"
        value={receivedAmount}
        onChange={(e) => setReceivedAmount(e.target.value)}
        placeholder="Enter received amount"
      />

      <div className="mt-3 d-flex justify-content-end gap-2">
        <button
          className="close-btn"
          onClick={() => setAdjustOrder(null)}
        >
          Cancel
        </button>

        <button
          className="edit-btn"
          onClick={handleUpdateReceived}
        >
          Submit
        </button>
      </div>

    </div>
  </section>
)}


{showEdit && (
                <section className='detail-dialog px-4 py-4 overflow-y-auto'>
                    <div className='detail-dialog-inner col-md-11 animate__animated animate__zoomIn rounded ms-auto px-3 py-3' onClick={(e) => e.stopPropagation()}>
                      <button className='float-end close-btn' onClick={() => setShowEdit(false)}>Close</button>

<EditSale setLoading={setLoading} selectedOrder={selectedOrder} setShowEdit={setShowEdit} setResponse={setResponse} 
 onUpdate={() => {
    fetchOrders(selectedDate);
  }}/>
    </div>
  </section>
)}

{loading && <Loading setLoading={setLoading} />}



    </>
  )
}

export default SaleHistory
